import { render, staticRenderFns } from "./requirementTerms.vue?vue&type=template&id=8b1dc990"
import script from "./requirementTerms.vue?vue&type=script&lang=js"
export * from "./requirementTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports